import api from './api';

export const guardarRespuestas = async (respuestas) => {
  const response = await api.put('/respuestas/guardar', { respuestas });
  return response.data;
};
